export default __webpack_public_path__ + "static/media/NETCCN-ONE-Icon.5d29a1f3.svg";